<template>
  <div class="login-wrapper">
    <div class="login-container">
      <!-- Left Side - Brand Section (Hidden on mobile) -->
      <div class="login-left">
        <div class="brand-content">
          <div class="brand-logo">
             <img src="@/assets/logo2.png" alt="logo" class="rounded" >
          </div>
          
          <div class="brand-tagline">
            <h2>Welcome Back!</h2>
            <p>Sign in to continue your journey with</p>
          </div>
          
          <div class="brand-footer">
            <p>&copy; 2026 Aurora. All rights reserved.</p>
          </div>
        </div>
      </div>
      <div class="login-right">
        <div class="form-container">
          <div class="form-header">
            <h3>Sign In</h3>
            <p>Enter your credentials to access your account</p>
          </div>

          <form id="main_form" @submit.prevent="handle_login" class="login-form">
            <!-- Email field -->
            <div class="input-group">
              <div class="input-field">
                <i class="fas fa-envelope"></i>
                <input 
                  id="email"
                  ref="emailInput"
                  type="email" 
                  name="email"
                  v-model="loginForm.email" 
                  placeholder="Enter your email" 
                  autocomplete="email"
                  required
                />
              </div>
            </div>

            <!-- Password field -->
            <div class="input-group">
              <div class="input-field">
                <i class="fas fa-lock"></i>
                <input 
                  id="password"
                  ref="passwordInput"
                  :type="showPassword ? 'text' : 'password'"
                  name="password"
                  v-model="loginForm.password" 
                  placeholder="Enter your password" 
                  autocomplete="current-password"
                  required
                />
                <i 
                  class="fas" 
                  :class="showPassword ? 'fa-eye-slash' : 'fa-eye'"
                  @click="togglePasswordVisibility"
                ></i>
              </div>
            </div>

            <!-- Form extras -->
            <div class="form-extras">
              <label class="checkbox-label">
                <input type="checkbox" v-model="rememberMe" />
                <span>Remember me</span>
              </label>
              <a href="#" class="forgot-link" @click.prevent="showForgotHint">Forgot password?</a>
            </div>

            <!-- Login button -->
            <button type="submit" class="login-btn" :disabled="loading">
              <i class="fas" :class="loading ? 'fa-spinner fa-spin' : 'fa-arrow-right-to-bracket'"></i>
              {{ loading ? 'Signing in...' : 'Sign In' }}
            </button>

            <!-- Signup prompt -->
            <!-- <div class="signup-prompt">
              <span>Don't have an account?</span>
              <button type="button" class="signup-btn" @click="triggerSignup">
                Sign up now <i class="fas fa-arrow-right"></i>
              </button>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { form_api_submit } from '../../utils/FormSubmit'

export default {
  name: 'Login',
  data() {
    return {
      loginForm: {
        email: '',
        password: '',
      },
      error_msg: '',
      showPassword: false,
      rememberMe: false,
      loading: false,
    };
  },
  mounted() {
    if (localStorage.getItem('remembered_email')) {
      this.rememberMe = true;
      this.loginForm.email = localStorage.getItem('remembered_email');
    }
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    
    async handle_login() {
      this.loading = true;
      this.error_msg = '';

      // Handle remember me
      if (this.rememberMe) {
        localStorage.setItem('remembered_email', this.loginForm.email);
      } else {
        localStorage.removeItem('remembered_email');
      }

      const fullUrl = "auth/login";

      const result = await form_api_submit({
        url: fullUrl,
        method: 'POST',
        data: this.loginForm,
        curr_form_id: '#main_form',
        take_form_data: false
      });

     if (result.success) {
          const data = result.data;
        console.log('Login successful:', data);
          localStorage.setItem('user_token',       data.token);
          localStorage.setItem('user_fname',       data.user.first_name);
          localStorage.setItem('user_lname',       data.user.last_name);
          localStorage.setItem('user_email',       data.user.email);
          localStorage.setItem('user_id',          data.user.id);
          localStorage.setItem('user_external_id', data.user.external_id);

          if (data.companies_count === 1) {
              // Single company — store it and go straight to dashboard
              localStorage.setItem('company_id',    data.company.id);
              localStorage.setItem('company_name',  data.company.name);
              localStorage.setItem('company_email', data.company.email  || '');
             this.$router.push('/dashboard');
          } else {
              // Multiple (or zero) companies — let them pick
             this.$router.push('/select-company');
          }
      }
      this.loading = false;
    },
    
    showForgotHint() {
      alert("Password reset link will be sent to your email address.");
    },
    
    triggerSignup() {
      this.$router.push('/signup');
    }
  }
};
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.login-wrapper {
  height: 100vh;
  width: 100vw;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: fixed;
  top: 0;
  left: 0;
}

.login-container {
  display: flex;
  width: 1000px;
  height: 600px;
  background: white;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
}

/* Left Side Styles */
.login-left {
  flex: 1;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 40px 35px;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
}

.brand-content {
  position: relative;
  z-index: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.brand-logo {
  display: flex;
  align-items: center;
  gap: 12px;
}

.brand-logo img {
  max-width: 150px;
  height: auto;
}

.brand-logo i {
  font-size: 40px;
  color: white;
}

.brand-logo h1 {
  font-size: 32px;
  color: white;
  margin: 0;
  font-weight: 700;
}

.brand-tagline {
  margin: 40px 0;
}

.brand-tagline h2 {
  font-size: 28px;
  color: white;
  margin-bottom: 12px;
  font-weight: 600;
}

.brand-tagline p {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.5;
}

.brand-footer p {
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  margin: 0;
}

/* Right Side Styles - Desktop (Left Aligned) */
.login-right {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 40px 35px;
  background: white;
  height: 100%;
  overflow-y: auto;
}

.login-right::-webkit-scrollbar {
  width: 0;
  background: transparent;
}

.form-container {
  width: 100%;
  max-width: 100%;
  margin-left: 0;
  margin-right: auto;
}

.form-header {
  text-align: left;
  margin-bottom: 30px;
}

.form-header h3 {
  font-size: 26px;
  color: #333;
  margin-bottom: 8px;
  font-weight: 600;
}

.form-header p {
  font-size: 13px;
  color: #666;
}

.login-form {
  width: 100%;
}

.input-group {
  margin-bottom: 20px;
  width: 100%;
}

.input-field {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
}

.input-field i:first-child {
  position: absolute;
  left: 15px;
  color: #999;
  font-size: 16px;
  z-index: 1;
}

.input-field input {
  width: 100%;
  padding: 12px 15px 12px 45px;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  font-size: 14px;
  transition: all 0.3s ease;
  font-family: inherit;
  background: white;
  box-sizing: border-box;
}

.input-field input:focus {
  outline: none;
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.input-field input::placeholder {
  color: #bbb;
  font-size: 13px;
}

.input-field i:last-child {
  position: absolute;
  right: 15px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s ease;
  z-index: 1;
}

.input-field i:last-child:hover {
  color: #667eea;
}

.form-extras {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 25px;
  width: 100%;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 13px;
  color: #666;
}

.checkbox-label input {
  cursor: pointer;
  margin: 0;
}

.forgot-link {
  font-size: 13px;
  color: #667eea;
  text-decoration: none;
  transition: color 0.3s ease;
}

.forgot-link:hover {
  color: #764ba2;
  text-decoration: underline;
}

.login-btn {
  width: 100%;
  padding: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  box-sizing: border-box;
}

.login-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
}

.login-btn:active:not(:disabled) {
  transform: translateY(0);
}

.login-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.signup-prompt {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #f0f0f0;
  width: 100%;
}

.signup-prompt span {
  font-size: 13px;
  color: #666;
  margin-right: 8px;
}

.signup-btn {
  background: none;
  border: none;
  color: #667eea;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: color 0.3s ease;
}

.signup-btn:hover {
  color: #764ba2;
}

.signup-btn i {
  font-size: 11px;
  margin-left: 5px;
}

/* Hide scrollbar on body */
body {
  overflow: hidden;
}

/* Mobile View - Hide left div */
@media (max-width: 768px) {
  .login-left {
    display: none !important;
  }
  
  .login-container {
    flex-direction: column;
    width: 90%;
    height: auto;
    max-width: 400px;
    min-height: auto;
  }
  
  .login-right {
    padding: 40px 30px;
    justify-content: center;
  }
  
  .form-container {
    max-width: 100%;
    margin: 0 auto;
  }
  
  .form-header {
    text-align: center;
  }
  
  .form-header h3 {
    font-size: 24px;
  }
  
  .form-header p {
    font-size: 12px;
  }
}

/* Small mobile devices */
@media (max-width: 480px) {
  .login-container {
    width: 95%;
    border-radius: 15px;
  }
  
  .login-right {
    padding: 30px 20px;
  }
  
  .form-header h3 {
    font-size: 22px;
  }
}
</style>